export default "__VITE_ASSET__CCLHKvH$__"